export default __webpack_public_path__ + "static/media/new_04.62d29fee.jpg";